
import React, { useEffect, useRef, useState } from "react";
import { Box, Button, IconButton, Typography } from "@mui/material";
import close from "../../../src/assests/images/Closered.svg";
import gallery from "../../../src/assests/images/gallaryIcon.svg";
import add from "../../../src/assests/images/plusRed.svg";
import { uploadimage } from "./api";
import { getToken } from "../../utils/utils";
import { useNavigate, useParams } from "react-router-dom";

interface ImageUploadBoxProps {
  largeimagedata: string | null;
  imageDataValue1: string | null;
  edit: any;
  keyvisuallength: any;
  setTopPanel: React.Dispatch<React.SetStateAction<string>>;
  setKeyVisual: React.Dispatch<React.SetStateAction<string>>;
}

interface ImageData {
  topPanel: string | null;
  keyVisual: { src: string; id: string }[];
}


const Imageuploadbrand: React.FC<ImageUploadBoxProps> = ({
  largeimagedata,
  imageDataValue1,
  keyvisuallength,
  setTopPanel,
  setKeyVisual
}) => {
  const [previews, setPreviews] = useState<Record<string, string | null>>({
    topPanel:  null,
  });

  const [previews1, setPreviews1] = useState<Record<string, string | null>>({
    topPanel: null,
  });
  const { id } = useParams();
  const token = getToken();

  const [imageData, setImageData] = useState<ImageData>({
    topPanel: null,
    keyVisual: [],  // Initialize keyVisual as an empty array
  });
  
  
  const [topPanel23, setTopPanel1] = useState<string>("");
  const [keyVisual23, setKeyVisual1] = useState<string>("");

   const handleFileUpload = async (file: File, key: string) => {
    if (!token) {
      alert("Please log in to upload files.");
      return;
    }

    const formData = new FormData();
    formData.append("answer", file);

    try {
      const response = await uploadimage(formData, token);
      const uploadedFileName = response.data.fileName;

      setPreviews((prev) => ({
        ...prev,
        [key]: URL.createObjectURL(file),
      }));

      if (key === "topPanel") {
        setTopPanel(uploadedFileName);
        setTopPanel1(uploadedFileName);
      } else {
        setKeyVisual((prev) =>
          prev ? `${prev}, ${uploadedFileName}` : uploadedFileName
        );
        setKeyVisual1((prev) =>
          prev ? `${prev}, ${uploadedFileName}` : uploadedFileName
        );
      }

      setImageData((prev) => ({
        ...prev,
        keyVisual: prev.keyVisual.map((image) =>
          `keyVisual-${image.id}` === key
            ? { src: uploadedFileName, id: image.id }
            : image
        ),
      }));
    } catch (error) {
      console.error("Image upload failed:", error);
    }
  };

  const [isDragging, setIsDragging] = useState<Record<string, boolean>>({
    topPanel: false,
    keyVisual1: false,
    keyVisual2: false,
  });

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
    key: string
  ) => {
    const file = event.target.files?.[0];
    if (!file) return;
  
    if (!token) {
      alert("Please log in to upload files.");
      return;
    }
  
    const formData = new FormData();
    formData.append("answer", file);
  
    try {
      const response = await uploadimage(formData, token);
      const uploadedFileName = response.data.fileName;
  
      setPreviews((prev) => ({
        ...prev,
        [key]: URL.createObjectURL(file),
      }));
  
      if (key === "topPanel") {
        setTopPanel(uploadedFileName);
      } else {
        setKeyVisual((prev) =>
          prev ? `${prev}, ${uploadedFileName}` : uploadedFileName
        );
      }
      setPreviews((prev) => ({ ...prev, [key]: URL.createObjectURL(file) }));
      setImageData((prev) => ({
        ...prev,
        keyVisual: prev.keyVisual.map((image) =>
          `keyVisual-${image.id}` === key
            ? { src: uploadedFileName, id: image.id }
            : image
        ),
      }));
    } catch (error) {
      console.error("Image upload failed:", error);
    }
  };
  console.log(topPanel23, "topPanel23topPanel23");
  console.log(keyVisual23, "afsdfsdfsdf");

  const navigate = useNavigate();

  const prevSelectedlocations = useRef(keyVisual23);
  useEffect(() => {
    if (
      keyVisual23 !== "" &&
      JSON.stringify(keyVisual23) !==
        JSON.stringify(prevSelectedlocations.current)
    ) {
      console.log(keyVisual23, "selectedLocations55");
      navigate(`/add-brand`, {
        state: { selectedkeyVisual23: keyVisual23 },
      });
      prevSelectedlocations.current = keyVisual23;
    }
  }, [keyVisual23]);

  const prevSelectedlocationstopPanel23 = useRef(topPanel23);
  useEffect(() => {
    if (
      topPanel23 !== "" &&
      JSON.stringify(topPanel23) !==
        JSON.stringify(prevSelectedlocationstopPanel23.current)
    ) {
      console.log(topPanel23, "selectedLocations55");
      navigate(`/add-brand`, {
        state: { selectedtopPanel23: topPanel23 },
      });
      prevSelectedlocationstopPanel23.current = topPanel23;
    }
  }, [topPanel23]);

  const handleRemoveImage = (key: string) => {
    setPreviews((prev) => ({ ...prev, [key]: null }));
  };
  console.log(keyVisual23, "topPaneltopPaneltopPanel444");
  const renderUploadBox = (key: string, button?: React.ReactNode, hideDefaultContent?: boolean) => (
    <Box
      onClick={() =>(document.getElementById(`${key}Input`) as HTMLInputElement)?.click()}

      onDragOver={(e) => {
        e.preventDefault();
        setIsDragging((prev) => ({ ...prev, [key]: true }));
      }}
      onDragLeave={() => setIsDragging((prev) => ({ ...prev, [key]: false }))}
      onDrop={(e) => {
        e.preventDefault();
        setIsDragging((prev) => ({ ...prev, [key]: false }));
        const droppedFile = e.dataTransfer.files[0];
        if (droppedFile) handleFileUpload(droppedFile, key);
      }}

      sx={{
        borderRadius: "12px",
        background: previews[key] ? "none" : "#FFF",
        border: previews[key] ? "none" : "2px dashed var(--60, #C5C6C7)",
        textAlign: "center",
        cursor: "pointer",
        position: "relative",
        overflow: "hidden",
        width: "100%",
        margin:'16px 0 24px',
        // padding:"48px 0",
        display:"flex",
        alignItems:"center",
        justifyContent:"center",
        height:"180px"
      }}
     >
      {previews[key] ? (
        <>
          <img
            src={previews[key]!}
            className="img-fluid"
            alt="Uploaded Preview"
            style={{
              // maxWidth: "595px",
              maxHeight: "100%",
              height: "245px",
              objectFit: "cover",
              width: "100%",
              borderRadius:"12px",
              backgroundColor:"#FFF"
            }}
          />
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              handleRemoveImage(key);
            }}
            sx={{
              position: "absolute",
              top: "5px",
              right: "5px",
              background: "#FFEBEF",
              color: "#000",
              borderRadius: "50%",
              padding: "5px 12px 12px",
              width: "32px",
              height: "32px",
              "&:hover": {
                background: "#FFEBEF",
              },
            }}
          >
            <Box>
              <img src={close} alt="" />
            </Box>
          </IconButton>
        </>
       ) : (
        !hideDefaultContent &&  key !== "keyVisual1" &&  ( // Conditionally render default content
          <Box>
            <img src={gallery} alt="gallery" />
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: "600",
                color: "#696A6B",
                margin: "8px 0 10px",
              }}
            >
              Drag & Drop your Image/Gif here or Choose file
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: "500",
                color: "#7D7E7F",
              }}
            >
              PNG, JPG, GIF, SVG (Max 5 MB)
            </Typography>
            {button}
          </Box>
        )
       )}
       <input
        id={`${key}Input`}
        type="file"
        accept="image/png, image/jpeg, image/gif, image/svg+xml"
        style={{ display: "none" }}
        onChange={(e) => handleFileChange(e, key)}
       />
       {button && !previews[key] && <Box sx={{ marginTop: "10px" }}>{button}</Box>} {/* Conditionally render "Add More" button */}
    </Box>
  );

console.log(imageData, "imageData5555")
  return (
    <>
      <Box>
        <Typography
          variant="h6"
          sx={{ fontSize: "18px", fontWeight: "600", color: "#282829" }}
        >
          Top Panel Image
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontSize: "16px",
            fontWeight: "400",
            color: "#696A6B",
            paddingTop: "2px",
          }}
        >
          Upload a pack top panel image to display above the product information
          for retailers.
        </Typography>
        {renderUploadBox("topPanel")}
      </Box>
      <Box>
        <Typography
          variant="h6"
          sx={{ fontSize: "18px", fontWeight: "600", color: "#282829" }}
        >
          Key Visual Images (Optional)
          
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontSize: "16px",
            fontWeight: "400",
            color: "#696A6B",
            paddingTop: "2px",
          }}
        >
          Upload Key visuals of the pack like front, side, and back view of the
          product.
        </Typography>
      </Box>
      <Box sx={{ display: "flex", gap: "24px" }}>
      {renderUploadBox(
          "keyVisual1",
          <Box sx={{Padding:"48px 0 !important"}}>
            <img src={gallery} alt="" />
            <Typography sx={{fontSize:"12px",fontWeight:"500",marginTop:"12px",color:"#7D7E7F"}} variant="h5">PNG, JPG,GIF,SVG (Max 5 MB)</Typography>
          </Box>,
          true
        )}
        {renderUploadBox(
          "keyVisual2",
          <Button sx={{borderRadius:"8px",border:"1px solid #C8172F",padding:"12px 16px",fontSize:"14px",fontWeight:"500",color:"#C8172F",textTransform:"unset"}}>
            <img style={{marginRight:"8px"}} src={add} alt="" /> Add More
          </Button>,
          true
        )}
      </Box>
    </>
  );
};

export default Imageuploadbrand;
